// Mock data for NT Studios website

export const companyInfo = {
  name: "NT Studios",
  tagline: "Crafting Digital Experiences That Inspire",
  logo: "https://customer-assets.emergentagent.com/job_techcraft-agency-3/artifacts/1g2a8lew_NT%20Studios%20White.png",
  logoDark: "https://customer-assets.emergentagent.com/job_techcraft-agency-3/artifacts/vmmw9tf0_NT%20Studios%20Black.png"
};

export const story = {
  title: "Our Story",
  content: "Founded with a passion for innovation and creativity, NT Studios has emerged as a leading force in digital development. We specialize in transforming bold ideas into exceptional digital experiences. Our team combines technical expertise with creative vision to deliver solutions that not only meet but exceed expectations. From interactive web applications to immersive educational games, we craft experiences that engage, educate, and inspire."
};

export const services = [
  {
    id: 1,
    title: "Website Development",
    description: "Custom-built, responsive websites that combine stunning design with seamless functionality. We create digital experiences that captivate your audience and drive results.",
    icon: "Globe"
  },
  {
    id: 2,
    title: "Web Applications",
    description: "Powerful, scalable web applications tailored to your business needs. From concept to deployment, we build solutions that streamline operations and enhance user experiences.",
    icon: "Layout"
  },
  {
    id: 3,
    title: "Game Development",
    description: "Engaging, immersive games that captivate players. We bring your gaming concepts to life with cutting-edge technology and creative storytelling.",
    icon: "Gamepad2"
  },
  {
    id: 4,
    title: "Educational Games",
    description: "Interactive learning experiences that make education fun and effective. Our educational games combine pedagogy with play to enhance learning outcomes.",
    icon: "GraduationCap"
  }
];

export const clients = [
  { id: 1, name: "TechCorp Global", logo: "TC" },
  { id: 2, name: "EduVision", logo: "EV" },
  { id: 3, name: "GameForge Studios", logo: "GF" },
  { id: 4, name: "Innovation Labs", logo: "IL" },
  { id: 5, name: "Digital Dynamics", logo: "DD" },
  { id: 6, name: "CreativeMind Inc", logo: "CM" }
];

export const projects = [
  {
    id: 1,
    title: "Neerang - Brand Website",
    description: "A beautiful, modern website showcasing the Neerang brand with elegant design and seamless user experience. Complete branding solution including logo design.",
    image: "https://customer-assets.emergentagent.com/job_studio-tools/artifacts/vwsg4l09_NeerangWebsite.png",
    type: "image",
    category: "Website"
  },
  {
    id: 2,
    title: "German With Aman - Educational Platform",
    description: "A visually appealing, well-structured website for German language learning. Features clean design and excellent user experience with professional branding.",
    image: "https://customer-assets.emergentagent.com/job_studio-tools/artifacts/z9e8x9i5_GermanWithAmanWebsite.png",
    type: "image",
    category: "Website"
  },
  {
    id: 3,
    title: "Separable Verbs Game",
    description: "An interactive educational game teaching German separable verbs. Players select and cut the correct separable verbs from a variety of German verb options.",
    image: "https://customer-assets.emergentagent.com/job_studio-tools/artifacts/117rdl82_SeparableVerbs.png",
    type: "image",
    category: "Educational Game"
  },
  {
    id: 4,
    title: "Separable Verbs - Gameplay",
    description: "Engaging gameplay mechanics that make learning German grammar fun and effective. Interactive cutting mechanic helps students master separable verbs.",
    image: "https://customer-assets.emergentagent.com/job_studio-tools/artifacts/os2uri1n_SeparableVerbs_2.png",
    type: "image",
    category: "Educational Game"
  }
];

export const tools = [
  {
    id: 1,
    title: "Email Generator",
    description: "Create professional, personalized emails in seconds. Perfect for outreach, marketing, and customer communication.",
    icon: "Mail",
    status: "Coming Soon"
  },
  {
    id: 2,
    title: "Content Brief Generator",
    description: "Generate comprehensive content briefs that guide your content creation process with clarity and precision.",
    icon: "FileText",
    status: "Coming Soon"
  },
  {
    id: 3,
    title: "Competitor Analysis",
    description: "Gain deep insights into your competition with automated analysis and actionable intelligence.",
    icon: "TrendingUp",
    status: "Coming Soon"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Lakhwinder Kaur",
    role: "CEO/Owner of Neerang",
    content: "NT Studios transformed our vision into reality and developed a beautiful website for our brand. The Communication was very clear, and their Attention to detail was very impressive. They also helped us with our Logo Design.",
    avatar: "LK"
  },
  {
    id: 2,
    name: "Amanpreet Kaur",
    role: "Owner of German With Aman",
    content: "The website design is visually appealing, well-structured, and easy to navigate. The overall user experience is excellent. Really love the logo! The design is clean, creative, and looks very professional. Great job overall.",
    avatar: "AK"
  },
  {
    id: 3,
    name: "Amanpreet Kaur",
    role: "Owner of German With Aman",
    content: "The Separable Verbs game is fantastic! It makes learning German grammar interactive and fun. My students love the cutting mechanic – it's intuitive and helps them understand verb separation perfectly. A brilliant educational tool!",
    avatar: "AK"
  }
];
